var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./AnswerReport.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getSettings, getTranslation } from "../../constants/setting";
import { currentLanguage, getAnswerReport, sendMessage, setAnswerReport } from "../../stores/reducers/chatReducer";
import { ANSWER_REPORT_INCORRECT_INFO, ANSWER_FEEDBACK_TYPE_INFORMATION_NEEDED, ANSWER_REPORT_NOT_RELEVANT, ANSWER_REPORT_OUTDATED, ANSWER_FEEDBACK_TYPE_ANSWER_WAS_HELPFUL } from "../../constants";
import { Button } from "react-bootstrap";
import { getHostname, getTextColor } from "../../helper";
import chatBotApi from "../../api/chatbot";
var AnswerReport = function () {
    var _b = getSettings(), primary_color = _b.primary_color, current_page_url = _b.current_page_url, subsite = _b.subsite;
    var dispatch = useDispatch();
    var getCurrentLanguage = useSelector(currentLanguage);
    var answerReport = useSelector(getAnswerReport);
    var onClicked = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _b, _j, _k, _q;
        return __generator(this, function (_w) {
            switch (_w.label) {
                case 0:
                    data = {
                        language: getCurrentLanguage,
                        type: type,
                        category: answerReport.data.category,
                        question: answerReport.data.question,
                        answer: (_b = answerReport.data) === null || _b === void 0 ? void 0 : _b.text,
                        search_results: _.filter((_j = answerReport.data) === null || _j === void 0 ? void 0 : _j.items, function (item, index) { var _b; return index < ((_b = answerReport.data) === null || _b === void 0 ? void 0 : _b.displayedItems); }),
                        is_global: ((_k = answerReport.data) === null || _k === void 0 ? void 0 : _k.is_global) || false,
                        is_ai_generated: ((_q = answerReport.data) === null || _q === void 0 ? void 0 : _q.is_ai_generated) || false,
                        referrer: subsite || getHostname(current_page_url)
                    };
                    return [4 /*yield*/, chatBotApi.addAnswerFeedback(data).then(function (response) {
                            setTimeout(function () {
                                var _b;
                                dispatch(sendMessage({
                                    response: __assign(__assign({}, response.data), (_b = {}, _b["hideFeedBackButton"] = true, _b))
                                }));
                            }, 1000);
                        }).catch(function (err) {
                            console.error(err);
                            console.error('something went wrong!');
                        }).finally(function () {
                            dispatch(setAnswerReport({}));
                        })];
                case 1:
                    _w.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var closeBtn = function () {
        dispatch(setAnswerReport({}));
    };
    return _jsxs("div", __assign({ className: styles.answerReportPopup }, { children: [_jsx("div", { className: styles.answerReportPopupOverlay, onClick: closeBtn }), _jsxs("div", __assign({ className: "d-flex flex-column gap-2 w-100 ".concat(styles.answerReportPopupWrapper) }, { children: [_jsx(Button, __assign({ type: "button", className: styles.answerReportPopupCloseButton, onClick: closeBtn, variant: "dark" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: 30, height: 30 }, { children: _jsx("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" }) })) })), _jsxs(Button, __assign({ type: "button", onClick: function () { return onClicked(ANSWER_FEEDBACK_TYPE_ANSWER_WAS_HELPFUL); }, variant: "primary", style: {
                            backgroundColor: primary_color,
                            borderColor: primary_color,
                            color: getTextColor(primary_color)
                        } }, { children: [" ", getTranslation('chatbot.answer_was_helpful'), " "] })), _jsxs(Button, __assign({ type: "button", onClick: function () { return onClicked(ANSWER_REPORT_NOT_RELEVANT); }, variant: "primary", style: {
                            backgroundColor: primary_color,
                            borderColor: primary_color,
                            color: getTextColor(primary_color)
                        } }, { children: [" ", getTranslation('chatbot.not_relevant'), " "] })), _jsxs(Button, __assign({ type: "button", onClick: function () { return onClicked(ANSWER_REPORT_INCORRECT_INFO); }, variant: "primary", style: {
                            backgroundColor: primary_color,
                            borderColor: primary_color,
                            color: getTextColor(primary_color)
                        } }, { children: [" ", getTranslation('chatbot.incorrect_info'), " "] })), _jsxs(Button, __assign({ type: "button", onClick: function () { return onClicked(ANSWER_REPORT_OUTDATED); }, variant: "primary", style: {
                            backgroundColor: primary_color,
                            borderColor: primary_color,
                            color: getTextColor(primary_color)
                        } }, { children: [" ", getTranslation('chatbot.outdated'), " "] })), _jsxs(Button, __assign({ type: "button", onClick: function () { return onClicked(ANSWER_FEEDBACK_TYPE_INFORMATION_NEEDED); }, variant: "primary", style: {
                            backgroundColor: primary_color,
                            borderColor: primary_color,
                            color: getTextColor(primary_color)
                        } }, { children: [" ", getTranslation('chatbot.information_needed'), " "] }))] }))] }));
};
export default AnswerReport;
